import React, { useState } from "react";
import AccordionUpload from "../../../../components/accordion/AccordionUpload";
import { UploadedFile } from "./domain";

interface IProjectFormProps {
  uploadedFiles: UploadedFile[];
  setUploadedFiles: React.Dispatch<React.SetStateAction<UploadedFile[]>>;
  disabled?: boolean
}

const UploadFilesForm: React.FC<IProjectFormProps> = ({
  uploadedFiles,
  setUploadedFiles,
  disabled = false
}) => {
  return (
    <>
      <AccordionUpload
        defaultExpanded
        required
        enableButtonLeft
        titleName="ไฟล์แนบ"
        uploadedFiles={uploadedFiles}
        setUploadedFiles={setUploadedFiles}
        acceptedFileTypes=".pdf,.doc,.docx,.jpg,.png,.xlsx"
        maxFileSize={5} // 5MB limit
        multiple={true}
        isView={disabled}
      />
    </>
  );
};

export default UploadFilesForm;
